export const RAPID_PRICEBOOK_REGION = 6